import { findElementAll, selectedElementAll } from "../utils/element-handlers.utils";
import $ from 'jquery';
import BootstrapCollapse from 'bootstrap/js/dist/collapse';

function CollapsibleComponent(collapsibleWrapperElement: HTMLElement) {
    var collapsibleId = collapsibleWrapperElement.getAttribute('data-n-collapsible');
    var $collapsibleWrapperElement = $(collapsibleWrapperElement);
    var $targetElements = $collapsibleWrapperElement.find('[data-n-collapsible-target]');
    var $toggleElements = $collapsibleWrapperElement.find('[data-n-collapsible-toggle]');
    var $externalAnchors = $('a[href="/#' + collapsibleId + '"]');
    var isVisible = $targetElements.hasClass('show');

    const collapseInstances = findElementAll('[data-n-collapsible-target]', collapsibleWrapperElement)
        .map(targetElement => new BootstrapCollapse(targetElement, {toggle: false}));

    $targetElements.addClass('collapsed collapse');
    $toggleElements.html(isVisible ? 'Show less' : 'Show more');

    $toggleElements.on('click', function () {
        isVisible = !$targetElements.hasClass('show');
        collapseToggle();
        $toggleElements.html(isVisible ? 'Show less' : 'Show more');
    });

    $externalAnchors.on('click', function () {
        collapseToggle();
        $toggleElements.html('Show less');
    });

    function collapseToggle() {
        collapseInstances.forEach(collapseInstance => collapseInstance.toggle());
    }
}

export default function initCollapsibleComponent() {
    selectedElementAll('[data-n-collapsible]', CollapsibleComponent);
}
